<template>
  <div>
    <h1>Our Services</h1>
    <div class="services-grid">
      <div class="service-card">
        <h3>Custom Software</h3>
        <p>Tailored solutions designed to boost efficiency.</p>
      </div>
      <div class="service-card">
        <h3>Mobile Development</h3>
        <p>We create stunning apps for iOS and Android.</p>
      </div>
      <div class="service-card">
        <h3>AI & Automation</h3>
        <p>Harness the power of artificial intelligence.</p>
      </div>
    </div>
  </div>
</template>

<style>
.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 25px;
  margin-top: 20px;
}

.service-card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

.service-card h3 {
  color: #4A5D23;
  font-size: 22px;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}
</style>
